import React from "react";
import { Link } from "react-router-dom";

function About() {
  return (
    <>
      <div className=" container">
        <h1 className=' text-xl font-semibold justify-center text-center  pt-28 '>About Us</h1>
        <hr className='my-2 px-10 text-[#d3d3d3] outline-dotted' />
        <div className="row px-4  pt-4">
          <div className="col-md-6">
            <p className="text-xl font-semibold pb-2">MsCube Tech</p>
            <p className="text-sm">
              At MSCUBE TECH, we don't just create digital solutions; we craft experiences that resonate. As a leading provider of cutting-edge technology and creative services, we offer a diverse portfolio tailored to meet your unique needs. With a passion for innovation and a commitment to excellence, MSCUBE TECH is your trusted partner on the journey to digital success.

            </p>
            <div className="">
              <Link to="/contact">  <button className="border-0  btn btn-success rounded-0  hover:bg-[#d60fb5] hover:text-[#fff]  mt-4 text-xs mr-4 uppercase">Contact</button> </Link>

            </div>

          </div>
          <div className="col-md-6 pt-2 ">
            <img className="w-44 h-54" src="./image/favicon.png" alt="" />
          </div>
        </div>

        <div className="">
          <div className="row w-100 py-10 px-4 pt-4">
            <div className="col-md-6 pt-2">
              <img src="./image/main11.jpg" alt="" />
            </div>
            <div className="col-md-6">
              <p className="text-xl font-semibold pb-2"> Our Expertise</p>
              <p className="text-xs">
                <b>Full-Stack Web Development:</b><br />
                From concept to deployment, we transform your ideas into fully functional, visually stunning websites. Our full-stack development team combines the latest technologies and best practices to create dynamic, responsive web solutions that engage your audience.
                <br />
                <b>App Development:</b><br />
                Harness the power of mobile with our custom app development services. Whether it's iOS, Android, or cross-platform, we create intuitive and feature-rich applications that captivate users and drive results.
                <br />
                <b>UI/UX Design: </b><br />
                Beauty meets functionality in our UI/UX designs. We prioritize user-centric design principles to deliver seamless, visually captivating interfaces that keep your audience engaged and delighted.
                <br />
                <b>WordPress & Shopify:</b><br />
                Unleash the potential of these popular content management systems with our expertise. Whether you need a stunning WordPress website or a high-converting Shopify e-commerce store, we've got you covered.
                <br />
                <b>Digital Marketing: </b><br />
                Take your online presence to the next level with our digital marketing strategies. We specialize in SEO, social media marketing, PPC, content marketing, and more to help you achieve your goals and boost your brand's visibility.

                <br />

              </p>

            </div>

          </div>

          <div className="row w-100 px-4 pt-4">
            <div className="col-md-6">
              <p className="text-xl font-semibold pb-2">Why Choose MsCube Tech?</p>
              <p className="text-xs">
                <b>Innovation:</b><br />
                We stay at the forefront of technology trends, ensuring your digital solutions are ahead of the curve.
                <br /><b>Experience: </b><br />
                With years of experience, our experts bring a wealth of knowledge to every project, big or small.
                <br />
                <b>Tailored Solutions: </b> <br />
                We understand that no two businesses are alike. Our solutions are customized to align with your unique goals and challenges.
                <br /> <b> Collaboration:</b> <br />
                We believe in transparent and collaborative partnerships. Your input and vision drive our process.
                <br />
                <b>Results-Oriented:</b>
                <br /> Our mission is to deliver measurable results. Your success is our success.
                <br />
                When you choose MSCUBE TECH, you're not just choosing a service provider; you're choosing a digital partner dedicated to your growth. Join us on this exciting journey to digital excellence. Contact us today, and let's bring your vision to life!

              </p>

            </div>
            <div className="col-md-6 pt-2">
              <img src="./image/main22.jpg" alt="" />
            </div>
          </div>

        </div>

      </div>



      <div className="section2 justify-center h-auto mt-24 text-[#ffff] bg-[#6a6dec] ">
        <h1 className=" pt-10 px-10 text-white text-2xl">Buil great products with  Front-end web development service.!</h1>
        <Link to="/contact">
          <button className="border-0 btn btn-success rounded-none font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>
        </Link>

      </div>

    </>


  );
}

export default About;
